const projects = [
    {
        title: 'ST. LEO CATHOILC ELEMENTARY SCHOOL REPLACEMENT',
        location: 'Toronto, ON',
        scope: 'PLUMBING, HVAC, BAS',
        value: '$6,028,000',
        gc: 'Pre. Eng Contracting Ltd',
        status: 'Completed',
        completionDate: 'Oct 2024',
        type: 'Expansion and Renovation',
        img: 'stLeoCatholic',
    },
    {
        title: '60 PLAYFAIR AVENUE RENOVATIONS FOR REGINA MUNDI',
        location: 'Toronto, ON',
        scope: 'Mechanical (HVAC, Plumbing & Controls)',
        value: '$2,678,000',
        gc: 'Corebuild Construction Ltd',
        status: 'Completed',
        completionDate: 'July 2024',
        type: 'Expansion and Renovation',
        img: 'playfair',
    },
    {
        title: 'BRADFORD COMMUNITY HUB',
        location: 'Bradford, ON',
        scope: 'Mechanical (HVAC, Plumbing & Controls)',
        value: '$200,000',
        gc: 'Domm Construction Ltd',
        status: 'Completed',
        completionDate: 'Feb 2022',
        type: 'Construction',
        img: 'bradfordCommHub',
    },
    {
        title: 'GARNETT A WILLIAMS COMMUNITY CENTRE RENOVATIONS',
        location: 'Toronto, ON',
        scope: 'Mechanical (HVAC, Plumbing & Controls)',
        value: '$2,418,000',
        gc: 'Steelcore Construction Ltd',
        status: 'Completed',
        completionDate: 'March 2024',
        type: 'Expansion and Renovation',
        img: 'garnetWilliams',
    },
    {
        title: 'YORK UNIVERISTY YEAR 3 CAMPUS WIDE RENO',
        location: 'Toronto, ON',
        scope: 'PLUMBING, HVAC',
        value: '$990,000',
        gc: 'CGI Contractors',
        status: 'Completed',
        completionDate: 'Feb 2022',
        type: 'Expansion and Renovation',
        img: 'york',
    },
    // {
    //     title: 'YORK UNIVERISTY LA & PS WASHROOM RENO',
    //     location: 'Toronto, ON',
    //     scope: 'HVAC',
    //     value: '$65,000',
    //     gc: 'Area Construction Inc',
    //     status: 'Completed',
    //     completionDate: 'Feb 2023',
    //     type: 'Expansion and Renovation',
    //     img: 'york',
    // },
    {
        title: 'CLARKSON SECONDARY SCHOOL',
        location: 'Mississauga, ON',
        scope: 'Mechanical (HVAC, Plumbing & Controls)',
        value: '$200,000',
        gc: 'Oreon Constructions and Management Ltd',
        status: 'Completed',
        completionDate: 'Feb 2022',
        type: 'Construction',
        img: 'clarksonSecondary',
    },
    {
        title: 'ELM DRIVE PUBLIC SCHOOL',
        location: 'Mississauga, ON',
        scope: 'Mechanical (HVAC, Plumbing & Controls)',
        value: null,
        gc: 'Torcom Construction Inc',
        status: 'Completed',
        completionDate: 'May 2021',
        type: 'Construction',
        img: 'elmDrive',
    },
    {
        title: 'CLEARVIEW LIBRARY',
        location: 'Stayner, ON',
        scope: 'Mechanical (HVAC, Plumbing & Controls)',
        value: '$380,000',
        gc: 'Bondfield Construction Company Ltd.',
        status: 'Completed',
        completionDate: 'January 2020',
        type: 'Construction',
        img: 'clearView',
    },
    {
        title: 'VAUGHAN FIRE STATION #7-4',
        location: 'Woodbridge, ON',
        scope: 'Mechanical (HVAC, Plumbing & Controls)',
        value: '$745,000',
        gc: 'Bondfield Construction Company Ltd.',
        status: 'Completed',
        completionDate: 'June 2017',
        type: 'Construction',
        img: 'vaughanFireStation',
    },
    {
        title: 'SOUTH MEADOW ELEMENTARY SCHOOL',
        location: 'Hamilton, ON',
        scope: 'Mechanical (HVAC, Plumbing & Controls)',
        value: '$2,250,000',
        gc: 'Tambro Construction Ltd.',
        status: 'Completed',
        completionDate: 'April 2021',
        type: 'Construction',
        img: 'southMeadowsElementary',
    },
    {
        title: 'ECOLE DYANE-ADAM ELEMENTARY FRENCH SCHOOL',
        location: 'Milton, ON',
        scope: 'Mechanical (HVAC, Plumbing & Controls)',
        value: '$1,810,000',
        gc: 'Pre-Eng Contracting Ltd.',
        status: 'Completed',
        completionDate: 'January 2020',
        type: 'Construction',
        img: 'ecoleDyane',
    },
    {
        title: 'VAUGHAN FIRE STATION #7-3 & EMS STATION #31',
        location: 'Woodbridge, ON',
        scope: 'Mechanical (HVAC, Plumbing & Controls)',
        value: '$745,000',
        gc: 'BECC Construction Group Ltd.',
        status: 'Completed',
        completionDate: 'June 2017',
        type: 'Construction',
        img: 'vaughanFireStation73',
    },
    {
        title: 'COUNTRYSIDE VILLAGE PUBLIC SCHOOL',
        location: 'Brampton, ON',
        scope: 'Mechanical (HVAC, Plumbing & Controls)',
        value: '$2,005,000',
        gc: 'Torcom Construction Inc',
        status: 'Completed',
        completionDate: 'November 2016',
        type: 'Construction',
        img: 'countrySideVillageSchool',
    },
    {
        title: 'NORTON PARK PLACE COMMUNITY CENTRE',
        location: 'Brampton, ON',
        scope: 'HVAC, Plumbing & Controls',
        value: '$690,000',
        gc: 'Varcon Construction',
        status: 'Completed',
        completionDate: 'January 2014',
        type: 'Construction',
        img: 'norton',
    },
    // {
    //     title: 'NORTH OSHAWA EMERGENCY MEDICAL SERVICES',
    //     location: 'Oshawa, ON',
    //     scope: 'HVAC, Plumbing & Controls',
    //     value: '$245,000',
    //     gc: 'MJ Dixon Construction Ltd.',
    //     status: 'Completed',
    //     completionDate: 'September 2013',
    //     type: 'Construction',
    //     img: 'northOshwaEMS',
    // },
    // {
    //     title: 'GRAND VALLEY INSTITUTION FOR WOMEN',
    //     location: 'Kitchener, ON',
    //     scope: 'HVAC, Plumbing & Controls',
    //     value: '$676,000',
    //     gc: 'Varcon Construction',
    //     status: 'Completed',
    //     completionDate: 'September 2013',
    //     type: 'Construction',
    //     img: 'grandValleyInstitute',
    // },
    // {
    //     title: 'ST. JOHN PAUL II CATHOLIC SCHOOL',
    //     location: 'Whitby, ON',
    //     scope: 'HVAC & Plumbing',
    //     value: '$1,035,000',
    //     gc: 'Everstrong Construction',
    //     status: 'Completed',
    //     completionDate: 'Sep 2014',
    //     type: 'Construction',
    //     img: 'stJohnPaul',
    // },

    // Expansion and Renovation
    {
        title: 'BIALIK HEBREW DAY SCHOOL',
        location: 'Maple, ON',
        scope: 'Mechanical (HVAC, Plumbing & Controls)',
        value: '$620,000',
        gc: 'Torcom Construction Inc.',
        status: 'Completed',
        completionDate: 'August 2019',
        type: 'Expansion and Renovation',
        img: 'bialikHebrew',
    },
    {
        title: 'FATHER MICHAEL GOETZ SECONDARY SCHOOOL',
        location: 'Mississauga, ON',
        scope: 'Mechanical (HVAC, Plumbing & Controls)',
        value: '$1,100,000',
        gc: 'Anacond Contracting Inc.',
        status: 'Completed',
        completionDate: 'August 2019',
        type: 'Expansion and Renovation',
        img: 'fatherMicheal',
    },
    {
        title: 'MAYFAIR CLUBS',
        location: 'Toronto, ON',
        scope: 'Mechanical (HVAC, Plumbing & Controls)',
        value: '$395,000',
        gc: 'Brown Daniels Associates',
        status: 'Completed',
        completionDate: 'January 2019',
        type: 'Expansion and Renovation',
        img: 'mayfairClub',
    },
    {
        title: 'RUTH THOMPSON MIDDLE SCHOOL',
        location: 'Mississauga, ON',
        scope: 'HVAC, Plumbing & Controls',
        value: '$310,000',
        gc: 'Orion Construction & Mgmt Ltd.',
        status: 'Completed',
        completionDate: 'November 2018',
        type: 'Expansion and Renovation',
        img: 'ruthThompson',
    },
    {
        title: 'ALL SAINTS CATHOLIC ELEMENTARY SCHOOL & ST HELEN SEPERATE SCHOOL',
        location: 'Mississauga, ON',
        scope: 'HVAC, Plumbing & Controls',
        value: '$245,000',
        gc: 'HN Construction Ltd.',
        status: 'Completed',
        completionDate: 'August 2018',
        type: 'Expansion and Renovation',
        img: 'allSaints',
    },
    {
        title: 'THORNDALE PUBLIC SCHOOL',
        location: 'Brampton, ON',
        scope: 'HVAC, Plumbing & Controls',
        value: '$208,000',
        gc: 'Century Group Inc.',
        status: 'Completed',
        completionDate: 'September 2018',
        type: 'Expansion and Renovation',
        img: 'thorndale',
    },
    // {
    //     title: 'ECOLE ELEMENTAIRE JEANNE LEJOIE',
    //     location: 'Toronto, ON',
    //     scope: 'HVAC, Plumbing & Controls',
    //     value: '$48,000',
    //     gc: 'Brown Daniels Associates',
    //     status: 'Completed',
    //     completionDate: 'September 2018',
    //     type: 'Expansion and Renovation',
    //     img: 'ecole',
    // },
    {
        title: 'KEATON CENTRE',
        location: 'Mississauga, ON',
        scope: 'HVAC, Plumbing & Controls',
        value: '$249,000',
        gc: 'Morosons Construction Ltd.',
        status: 'Completed',
        completionDate: 'July 2018',
        type: 'Expansion and Renovation',
        img: 'keaton',
    },
    // {
    //     title: 'RICHVIEW LIBRARY',
    //     location: 'Toronto, ON',
    //     scope: 'HVAC, Plumbing & Controls',
    //     value: '$94,750',
    //     gc: 'PRE-ENG Contracting Ltd.',
    //     status: 'Completed',
    //     completionDate: 'June 2018',
    //     type: 'Expansion and Renovation',
    //     img: 'richView',
    // },
    {
        title: '6 VARIOUS SCHOOL EXHAUST FAN REPLACEMENT',
        location: 'Brampton & Mississauga, ON',
        scope: 'HVAC',
        value: '$270,000',
        gc: 'Anacond Construction Inc.',
        status: 'Completed',
        completionDate: 'February 2018',
        type: 'Expansion and Renovation',
        img: 'richView',
    },
    {
        title: 'TATHAM HALL RESIDENCE YORK UNIVERSITY',
        location: 'Toronto, ON',
        scope: 'HVAC, Plumbing & Controls',
        value: '$1,100,000',
        gc: 'Pomerleau Inc.',
        status: 'Completed',
        completionDate: 'August 2017',
        type: 'Expansion and Renovation',
        img: 'thatamHall',
    },
    {
        title: 'HUTTONVILLE PUBLIC SCHOOL',
        location: 'Brampton, ON',
        scope: 'HVAC, Plumbing & Controls',
        value: '$1,300,000',
        gc: 'Tambro Construction Ltd.',
        status: 'Completed',
        completionDate: 'August 2017',
        type: 'Expansion and Renovation',
        img: 'huttonville',
    },
    {
        title: 'WINTER & VANIERS RESIDENCE YORK UNIVERSITY',
        location: 'Toronto, ON',
        scope: 'HVAC, Plumbing & Controls',
        value: '$1,400,000',
        gc: 'Brown Daniels Associates',
        status: 'Completed',
        completionDate: 'August 2016',
        type: 'Expansion and Renovation',
        img: 'winterAndWaniers',
    },
    {
        title: 'MUNDEN PARK PUBLIC SCHOOL',
        location: 'Mississauga, ON',
        scope: 'HVAC, Plumbing & Controls',
        value: '$500,000',
        gc: 'Brown Daniels Associates',
        status: 'Completed',
        completionDate: 'March 2015',
        type: 'Expansion and Renovation',
        img: 'mundenPark',
    },
    // {
    //     title: 'JAMES POTTER PUBLIC SCHOOL',
    //     location: 'Brampton, ON',
    //     scope: 'HVAC, Plumbing & Controls',
    //     value: '$75,000',
    //     gc: 'Tambro Construction Ltd.',
    //     status: 'Completed',
    //     completionDate: 'November 2014',
    //     type: 'Expansion and Renovation',
    //     img: 'jamesPotter',
    // },
    {
        title: 'OSCAR PETERSON PUBLIC SCHOOL',
        location: 'Mississauga, ON',
        scope: 'HVAC, Plumbing & Controls',
        value: '$900,000',
        gc: 'Trustco Construction',
        status: 'Completed',
        completionDate: 'October 2014',
        type: 'Expansion and Renovation',
        img: 'oscarPeterson',
    },
    // {
    //     title: 'FAIRVIEW PUBLIC SCHOOL',
    //     location: 'Mississauga, ON',
    //     scope: 'HVAC, Plumbing & Controls',
    //     value: '$45,000',
    //     gc: 'Tri-Green Construction Inc.',
    //     status: 'Completed',
    //     completionDate: 'September 2014',
    //     type: 'Expansion and Renovation',
    //     img: 'fairview',
    // },
    {
        title: 'JEFFERSON PUBLIC SCHOOL',
        location: 'Brampton, ON',
        scope: 'HVAC, Plumbing & Controls',
        value: '$100,000',
        gc: 'Tri-Green Construction Inc.',
        status: 'Completed',
        completionDate: 'September 2014',
        type: 'Expansion and Renovation',
        img: 'jefferson',
    },
    {
        title: 'ST. SEBASTIAN CATHOLIC ELEMENTARY SCHOOL',
        location: 'Mississauga, ON',
        scope: 'HVAC, Plumbing & Controls',
        value: '$130,000',
        gc: 'MJ Dixon Construction Ltd.',
        status: 'Completed',
        completionDate: 'September 2014',
        type: 'Expansion and Renovation',
        img: 'stSebastian',
    },
    // {
    //     title: 'CHURCHILL MEADOWS PUBLIC SCHOOL',
    //     location: 'Mississauga, ON',
    //     scope: 'HVAC, Plumbing & Controls',
    //     value: '$42,000',
    //     gc: 'Everstrong Construction Ltd.',
    //     status: 'Completed',
    //     completionDate: 'August 2014',
    //     type: 'Expansion and Renovation',
    //     img: 'churchillMeadow',
    // },
    // {
    //     title: 'DANTE ALIGHIERY ACADEMY - 70 PLAYFAIR AVENUE',
    //     location: 'Toronto, ON',
    //     scope: 'HVAC, Plumbing & Controls',
    //     value: null,
    //     gc: 'Pre-Eng Contracting Ltd.',
    //     status: 'In Progress',
    //     completionDate: 'August 2014',
    //     type: 'Expansion and Renovation',
    //     img: 'DanteAlighieri',
    // },
    {
        title: 'HOLLYWOOD PUBLIC SCHOOL ADDITION & RENOVATION',
        location: 'Toronto, ON',
        scope: 'HVAC, Plumbing & Controls',
        value: null,
        gc: 'Pre-Eng Contracting Ltd.',
        status: 'Completed',
        completionDate: 'September 2025',
        type: 'Expansion and Renovation',
        img: 'HollywoodPublicSchool',
    },
];

export default projects;
